/**
 * Node.js environment object.
 *
 * Directly exposes `process.env`.
 */
export const env = process.env;
//# sourceMappingURL=env.js.map